var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/dataHandler/index.ts
var unitHandler = (numberData) => {
  const numberDataLength = String(numberData).length;
  if (numberDataLength <= 4) {
    return { result: numberData, unit: "" };
  }
  if (numberDataLength > 4 && numberDataLength < 8) {
    return { result: Math.ceil(numberData / 1e4), unit: "万" };
  }
  return {
    result: Math.ceil(numberData / 1e7) / 10,
    unit: "亿"
  };
};
var getRangeList = (start, end, step) => {
  const list = [];
  for (let i = start; i <= end; i += step) {
    list.push(i);
  }
  return list;
};
var idCardDesensitization = (idCard) => {
  const idCardLen = idCard.length;
  const idCardDesensitization2 = idCard.substring(0, 6) + "****" + idCard.substring(idCardLen - 4, idCardLen);
  return [idCardDesensitization2, idCard];
};
var nameDesensitization = (name) => {
  const nameLen = name.length;
  const nameDesensitization2 = name.substring(0, 1) + "*" + name.substring(nameLen - 1, nameLen);
  return [nameDesensitization2, name];
};
var getYearRangeToNow = (start) => {
  const end = new Date().getFullYear();
  const list = [];
  for (let i = start; i <= end; i++) {
    list.push(i);
  }
  return list.reverse();
};

// src/expireLocalStorage/index.ts
function setWithExpiry(key, value, ttl, storageType = "local") {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl
  };
  if (storageType === "local") {
    window.localStorage.setItem(key, JSON.stringify(item));
  } else {
    window.sessionStorage.setItem(key, JSON.stringify(item));
  }
}
function getWithExpiry(key, storageType = "local") {
  if (storageType === "local") {
    const itemStr = window.localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      window.localStorage.removeItem(key);
      return { isExpired: true, value: item.value };
    }
    return { isExpired: false, value: item.value };
  } else {
    const itemStr = window.sessionStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      window.sessionStorage.removeItem(key);
      return { isExpired: true, value: item.value };
    }
    return { isExpired: false, value: item.value };
  }
}
var saveToken = (id, token, ttl = 3e5, storageType = "local") => __async(void 0, null, function* () {
  setWithExpiry(id, token, ttl, storageType);
});
var destroyToken = (id, storageType = "local") => {
  if (storageType === "local") {
    window.localStorage.removeItem(id);
  } else {
    window.sessionStorage.removeItem(id);
  }
};

// src/desensitization/index.ts
var desensitization_exports = {};
__export(desensitization_exports, {
  cnName: () => cnName,
  idCard: () => idCard_exports,
  phone: () => phone_exports
});

// src/desensitization/idCard.ts
var idCard_exports = {};
__export(idCard_exports, {
  normal: () => normal,
  strong: () => strong
});
function normal(idCard) {
  const front = [idCard[0], idCard[4]].join("***");
  const middle = idCard.substring(5, 11);
  let tiler = [idCard[11], idCard[idCard.length - 1]];
  if (idCard.length === 15) {
    tiler = tiler.join("**");
  } else {
    tiler = tiler.join("*****");
  }
  const target = [front, middle, tiler].join("");
  return {
    source: idCard,
    target
  };
}
function strong(idCard) {
  const firstNum = idCard[0];
  const lastNum = idCard[idCard.length - 1];
  let target = [firstNum, lastNum].join("****************");
  if (idCard.length === 15) {
    target = [firstNum, lastNum].join("*************");
  }
  return {
    source: idCard,
    target
  };
}

// src/desensitization/phone.ts
var phone_exports = {};
__export(phone_exports, {
  phone: () => phone
});
function phone(phoneNumber) {
  const topThree = phoneNumber.split("").slice(0, 3).join("");
  const lastFour = phoneNumber.split("").slice(-4).join("");
  const target = [topThree, lastFour].join("****");
  return {
    source: phoneNumber,
    target
  };
}

// src/desensitization/cnName.ts
function cnName(name) {
  const target = name.replace(/^./g, "*");
  return {
    source: name,
    target
  };
}

// src/xorEncryption/index.ts
function xorEncryption(str, key) {
  let result = "";
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    result += String.fromCharCode(charCode);
  }
  return result;
}

// src/base/index.ts
function getSlot(slots, props, prop = "default") {
  if (props[prop] === false) {
    return false;
  }
  return props[prop] || slots[prop];
}
var searchInTree = (root, condition) => {
  let stack = [];
  let node = null;
  let ii = null;
  if (Array.isArray(root)) {
    stack = [...root];
  } else {
    stack = [root];
  }
  while (stack.length > 0) {
    node = stack.shift();
    if (condition(node)) {
      return node;
    } else if (node.children && node.children.length) {
      for (ii = 0; ii < node.children.length; ii += 1) {
        stack.push(node.children[ii]);
      }
    }
  }
  return null;
};
var isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
export {
  desensitization_exports as Desensitization,
  destroyToken,
  getRangeList,
  getSlot,
  getWithExpiry,
  getYearRangeToNow,
  idCardDesensitization,
  isMobile,
  nameDesensitization,
  saveToken,
  searchInTree,
  setWithExpiry,
  unitHandler,
  xorEncryption
};
